export const hasRight = (formName, action) => {
  const rights = JSON.parse(sessionStorage.getItem("userRights") || "[]");

  const form = rights.find(r => r.formName === formName);
  if (!form) return false;

  switch (action) {
    case "view": return form.canView;
    case "add": return form.canAdd;
    case "update": return form.canUpdate;
    case "delete": return form.canDelete;
    default: return false;
  }
};
